
/** ErrorCodes support by CarmUI and Backend */
export const ErrorCodes = {
  Required: {
    code: 'REQUIRED',
    message: 'informationRequired',
  },
  Alphanumeric: {
    code: 'ALPHANUMERIC',
    message: 'alphanumericOnly',
  },
  Numeric: {
    code: 'NUMERIC',
    message: 'numericOnly',
  },
  MoneyPositive: {
    code: 'MONEY_POSITIVE',
    message: 'moneyPositive',
  },
  InvalidPaymentAmount: {
    code: 'INVALIDAMOUNT',
    message: 'invalidAmount',
  },
  PaymentMinAmount: {
    code: 'MINIMUM',
    message: 'paymentMinAmount',
  },
  PaymentMaxAmount: {
    code: 'MAXIMUM',
    message: 'paymentMaxAmount',
  },
  ThirteenDigits: {
    code: 'THIRTEENDIGITS',
    message: 'thirteenDigits',
  },
  Percentage: {
    code: 'PERCENTAGE',
    message: 'percentage',
  },
  MinimumLength: {
    code: 'MINIMUM',
    message: 'minimumLength',
  },
  MaximumLength: {
    code: 'MAXIMUM',
    message: 'maximumLength',
  },
  RangeLength: {
    code: 'RANGELENGTH',
    message: 'rangeLength',
  },
  InvalidCode: {
    code: 'INVALID_CODE',
    message: 'invalidClassificationCode',
  },
  InvalidTransactionId: {
    code: 'INVALID_TRANSACTION_ID',
    message: 'invalidTransactionId',
  },
  DraftExists: {
    code: 'DRAFT_EXISTS',
    message: 'draftExists',
  },
  InvalidEmail: {
    code: 'INVALID_EMAIL',
    message: 'invalidEmail',
  },
  InvalidB9: {
    code: 'INVALID_B9',
    message: 'invalidB9',
  },
  InvalidB3: {
    code: 'INVALID_B3',
    message: 'invalidB3',
  },
  B3NotFound: {
    code: 'B3_NOT_FOUND',
    message: 'B3NotFound',
  },
  AlreadtConvertB3: {
    code: 'B3_ALREADY_CONVERTED',
    message: 'carm.cad.b3.transaction.already.converted.error',
  },
  InvalidBN15: {
    code: 'INVALID_BN15',
    message: 'invalidBN15',
  },
  InvalidBusinessProgramId: {
    code: 'INVALID_BUSINESS_PROGRAM',
    message: 'invalidBusinessProgram',
  },
  EqualTo: {
    code: 'EQUAL_TO',
    message: 'notEqual',
  },
  MinValue: {
    code: 'MIN_VALUE',
    message: 'minValue',
  },
  MaxValue: {
    code: 'MAX_VALUE',
    message: 'maxValue',
  },
  RegistrationCarrierProgramId: {
    code: 'REGISTRATION_CARRIER_PROGRAMID',
    message: 'registrationCarrierProgramId',
  },
  RegistrationWarehouseProgramId: {
    code: 'REGISTRATION_WAREHOUSE_PROGRAMID',
    message: 'registrationWarehouseProgramId',
  },
  RegistrationDutyFreeShopProgramId: {
    code: 'REGISTRATION_DUTYFREESHOP_PROGRAMID',
    message: 'registrationDutyFreeShopProgramId',
  },
  DifferentTo: {
    code: 'DIFFERENT_TO',
    message: 'different',
  },
  InvalidOption: {
    code: 'INVALIDOPTION',
    message: 'invalidOption',
  },
  InvalidDateRange: {
    code: 'INVALID_DATE_RANGE',
    message: 'invalidDateRange',
  },
  InvalidDate: {
    code: 'INVALID_DATE_PROVIDED',
    message: 'invalidDateFormat',
  },
  FutureDate: {
    code: 'NOT_FUTURE_DATE_PROVIDED',
    message: 'enterFutureDate',
  },
  TodayOrLaterDate: {
    code: 'TODAY_OR_LATER_DATE_REQUIRED',
    message: 'todayOrLaterDate',
  },
  AtLeastOneRequired: {
    code: 'AT_LEAST_ONE_REQUIRED',
    message: 'atLeastOneRequired',
  },
  MustAccept: {
    code: 'MUST_ACCEPT',
    message: 'mustAccept',
  },
  ConfirmWordMustMatch: {
    code: 'WORD_MUST_MATCH',
    message: 'confirmWordMustMatch',
  },
  InvalidHas1AlphaCharacter: {
    code: 'ENTER_AT_LEAST_ONE_ALPHABETIC_CHARACTER',
    message: 'enterAtLeastOneAlphabeticCharacter',
  },
  InvalidHas1AlphaNumericCharacter: {
    code: 'ENTER_AT_LEAST_ONE_ALPHANUMERIC_CHARACTER',
    message: 'enterAtLeastOneAlphaNumericCharacter',
  },
  InvalidZipCode: {
    code: 'ENTER_VALID_ZIP_CODE',
    message: 'enterValidZipCode',
  },
  InvalidPostalCode: {
    code: 'ENTER_VALID_POSTAL_CODE',
    message: 'enterValidPostalCode',
  },
  InvalidCanadianPhoneNumber: {
    code: 'ENTER_VALID_CANADIAN_PHONE_NUMBER',
    message: 'enterValidCanadianPhoneNumber',
  },
  InvalidInternationalPhoneNumber: {
    code: 'ENTER_VALID_INTERNATIONAL_PHONE_NUMBER',
    message: 'enterValidInternationalPhoneNumber',
  },
  InvalidCanadianAreaCode: {
    code: 'ENTER_VALID_CANADIAN_AREA_CODE',
    message: 'enterValidCanadianAreaCode',
  },
  InvalidInternationalAreaCode: {
    code: 'ENTER_VALID_INTERNATIONAL_AREA_CODE',
    message: 'enterValidInternationalAreaCode',
  },
  InvalidExtensionNumber: {
    code: 'ENTER_VALID_EXTENSION_NUMBER',
    message: 'enterValidExtensionNumber',
  },
  ExpiryDate: {
    code: 'INVALID_EXPIRY_DATE',
    message: 'invalidExpiryDate',
  },
  InvalidEnrolmentPhone: {
    code: 'INVALID_ENROLMENT_PHONE',
    message: 'invalidEnrolmentPhone',
  },
  LesserOfAppliesRequired: {
    code: 'LESSER_OF_APPLIES',
    message: 'lesserOfAppliesRequired',
  },
  InvalidComplianceCaseNo: {
    code: 'INVALID_COMPLIANCE_CASE_NO',
    message: 'invalidComplianceCaseNo',
  },
  CadMaxQuantity: {
    code: 'INVALID_MAX_QUANTITY',
    message: 'maxValueGoodsQuantity',
  },
  ValueNotFound: {
    code: 'VALUE_NOT_FOUND',
    message: 'valueNotFound',
  },
  InvalidPhoneCode: {
    code: 'INVALID_PHONE',
    message: 'invalidPhone'
  }
};
